if (!customElements.get("feed-fetcher")) {
  customElements.define(
    "feed-fetcher",
    class FeedFetcher extends SectionFetcher {
      async connectedCallback() {
        this.dataset.sectionId =
          this.dataset.sectionId || "api--product-feed--feed-block";
        this.dataset.id = `product-feed--feed-block${this.dataset.url}`;
        this.dataset.fireEvent = "feed-fetcher:fetched";
        this.closest("product-feed")?.onFeedChange();
        if (this.dataset.onload !== "true") {
          super.connectedCallback();
          return;
        }
        // wait for scroll animation to finish, then call super.connectedCallback()
        await waitForScrollToEnd();
        super.connectedCallback();
      }
    }
  );
}
